import React from 'react';

export default function PrivacidadPage() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 24px', fontFamily: 'Arial, sans-serif', color: '#1f2937', lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, fontWeight: 700, marginBottom: 8, color: '#0f172a' }}>Política de Privacidad</h1>
      <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 32 }}>Última actualización: {new Date().toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>1. Responsable del tratamiento de datos</h2>
        <p>
          <strong>Activo Contadores</strong> (en adelante "la empresa"), con domicilio en México, RFC: <strong>CEHA870708ME6</strong>, representada por Agustín Pablo Celaya Hernández,
          es responsable del uso y protección de sus datos personales, en términos de lo dispuesto por la
          Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP).
        </p>
        <p>Para cualquier duda o solicitud relacionada con sus datos, puede contactarnos en:</p>
        <ul style={{ paddingLeft: 20 }}>
          <li><strong>Email:</strong> agustin@activocontadores.com</li>
          <li><strong>Teléfono:</strong> 664 494 0143</li>
          <li><strong>Domicilio:</strong> Calle Ryerson 106, Zona Centro, Ensenada, Baja California, C.P. 22800</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>2. Datos personales que recabamos</h2>
        <p>Para la prestación de nuestros servicios, podemos recabar los siguientes datos personales:</p>
        <ul style={{ paddingLeft: 20 }}>
          <li>Nombre completo o razón social</li>
          <li>RFC (Registro Federal de Contribuyentes)</li>
          <li>Correo electrónico</li>
          <li>Número de teléfono</li>
          <li>Régimen fiscal</li>
          <li>Información de pago (procesada de forma segura por Openpay — nosotros no almacenamos datos de tarjetas)</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>3. Finalidades del tratamiento</h2>
        <p>Sus datos personales serán utilizados para:</p>
        <ul style={{ paddingLeft: 20 }}>
          <li>Prestar los servicios contables y fiscales contratados</li>
          <li>Procesar pagos y emitir comprobantes</li>
          <li>Enviarle información relevante sobre sus obligaciones fiscales</li>
          <li>Contactarle para dar seguimiento a sus trámites</li>
          <li>Cumplir con obligaciones legales y fiscales ante las autoridades mexicanas (SAT, IMSS, etc.)</li>
        </ul>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>4. Transferencia de datos</h2>
        <p>
          Sus datos podrán ser compartidos con terceros únicamente cuando sea necesario para la prestación del servicio,
          incluyendo procesadores de pago (Openpay) y autoridades fiscales cuando así lo requiera la ley.
          No vendemos ni compartimos su información con fines publicitarios.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>5. Seguridad de los datos</h2>
        <p>
          Implementamos medidas técnicas y administrativas para proteger su información, incluyendo cifrado SSL/TLS,
          acceso restringido a la información y almacenamiento seguro. Los pagos son procesados por Openpay,
          empresa certificada bajo estándar PCI DSS, por lo que los datos de su tarjeta nunca pasan ni son
          almacenados en nuestros servidores.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>6. Derechos ARCO</h2>
        <p>
          Usted tiene derecho a <strong>Acceder, Rectificar, Cancelar u Oponerse</strong> al tratamiento de sus datos personales
          (derechos ARCO), conforme a la LFPDPPP. Para ejercer dichos derechos, envíe su solicitud a:
          <strong> agustin@activocontadores.com</strong> indicando nombre completo, datos de contacto y la acción que desea realizar.
          Responderemos en un plazo máximo de 20 días hábiles.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>7. Uso de cookies</h2>
        <p>
          Nuestro sitio utiliza cookies de sesión necesarias para el funcionamiento de la plataforma
          (autenticación y preferencias de usuario). No utilizamos cookies de seguimiento publicitario.
        </p>
      </section>

      <section style={{ marginBottom: 28 }}>
        <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 10, color: '#0f172a' }}>8. Cambios a este aviso</h2>
        <p>
          Nos reservamos el derecho de actualizar esta política en cualquier momento.
          Cualquier cambio será publicado en esta página con la fecha de actualización correspondiente.
        </p>
      </section>

      <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 20, marginTop: 32, color: '#6b7280', fontSize: 13 }}>
        <p>Activo Contadores · México · <a href="mailto:agustin@activocontadores.com" style={{ color: '#3280ed' }}>agustin@activocontadores.com</a></p>
      </div>
    </div>
  );
}
